module.exports = __webpack_public_path__ + "Flag-64.456d8a8fa45be2dda76d2873b967fa8c.svg";